export default {
    home: "首页",
    product: "产品中心",
    apply: "行业应用",
    zlykkx:'质量与可靠性',
    support: "服务支持",
    onlineClass:"在线课堂",
    tecArticles:"技术文章",
    aboutUs: "关于士模",
    introduce:'公司介绍',
    news:"新闻资讯",
    contact:'联系我们',
    xsydls:"销售与代理商",
    joinUs:"加入我们",
    LearnMore:"了解更多",
    ProductCenter:"产 品 中 心",
    IndustryApplication:"行 业 应 用",
    CompanyProfile:"公司介绍",
    InvestmentPartners:"投资伙伴",
    ContactUs:"联系我们",
    NewsCenter:"新 闻 资 讯",
    footer1:"聚焦高性能模拟信号链芯片设计",
    BeijingOffice:"北京公司",
    BeijingAddress:"北京市海淀区学清路10号院学清嘉创大厦A座9层",
    ChengduOffice:"成都公司",
    ChengduAddress:"成都市高新区吉泰路10号汇顶科技大厦1栋1单元10层",
    SalesInquiries:"销售咨询：",
    sales1:"（华北/西北/西南）",
    sales2:"（华东/华中）",
    sales3:"（华南）",
    sales4:"(全国)",
    Email:"邮箱",
    Sales:"销售",
    Recruitment:"招聘",
    service:"服务",
    FollowUs:"关注我们",
    NewProducts:"最新发布",
    ProductSelectionTable:"产品选型表",
    Filters:"筛选器",
    SearchPart:"查找产品型号",
    Reset:"重置",
        ProductInformation:"产品信息",
        Description:"概述",
        ProductVideo:"产品视频",
        Features:"特性",
        Applications:"应用",
        OrderingGuide:"订购信息",
        SalesInquiry:"销售咨询",
        address:"地区",
      phone:"电话",
      wechat:"微信",
      NewProductReleases:"最新发布",
      productDetail:"产品详情",


  }


// WEBPACK FOOTER //
// ./src/lang/zh.js